<template>
  <div id="bsczhu1">
    <div class="box">
      <div id="bsczhu1div" style="height:99%; visibility: hidden; display:none;"></div>
    </div>
  </div>
</template>

<script>
// 2：导入echarts
import echarts from 'echarts';

export default {
  name: 'bsczhu1',
  data() {
    return {
      // 需要合并对象，样式
      legendColor: false,
      mm: 5,
      dataset: [[-10, 5, -3]],
      NowYearTargetValue: ['内饰', '外饰', 'AYM']
    };
  },
  created() {},
  mounted() {
    //   mounted 函数表示已经DOM渲染完成
  },
  methods: {
    refreshChart(chartData) {
      var myChart = echarts.init(document.getElementById('bsczhu1div'));

      if (chartData === undefined) {
        myChart.clear()
        return
      }

      var option = {
        title: {
          text: '用电情况',
          textStyle: {
            color: '#fff',
            fontSize: 24
          },
          left: 'center'
        },
        color: ['#87CDEB', '#5FBCE4', '#40AFDF', '#239DD1', '#1E86B3', '#186B8F'],
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        legend: {
          // orient: 'vertical',
          // top: 'middle',
          bottom: 10,
          left: 'center',
          data: ['生产', '辅助', '附属']
        },
        series: [
          {
            type: 'pie',
            radius: '65%',
            center: ['50%', '50%'],
            selectedMode: 'single',
            data: [
              { value: 935, name: '生产' },
              { value: 510, name: '辅助' },
              { value: 234, name: '附属' }
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      };
      // 5：展示数据
      myChart.setOption(option);
    }
  }
};
</script>

<style lang="less" >
#bsczhu1 {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: rgba(6, 30, 93, 0.5);
  // border-top: 2px solid rgba(1, 153, 209, 0.5);
  box-sizing: border-box;
  margin-top: 10px;
  .box {
    height: 100%;
    width: 100%;
  }
}
</style>
